import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { PageHeader } from '@/components/layout';
import { useTranslations, useAssistantFilters } from '@/hooks';
import { MODULE_CERTIFICATE_TYPES } from '@/app/routes';
import emptyBoxIllustration from '@/assets/illustrations/empty-box.png';
import { TransactionsTable } from '../components/TransactionsTable';
import styles from './TransactionsPage.module.scss';

// Monitor ▸ Transactions — the account's ledger, newest first.
export const TransactionsPage = () => {
  const t = useTranslations();
  const { module } = useParams();
  const assistantFilters = useAssistantFilters();

  const emptyState = useMemo(
    () => ({
      image: <img src={emptyBoxIllustration} alt="" width={200} height={200} />,
      title: t('TRANSACTIONS_EMPTY_TITLE'),
      description: t('TRANSACTIONS_EMPTY_DESCRIPTION'),
    }),
    [t],
  );

  const noResults = useMemo(
    () => ({
      title: t('TRANSACTIONS_NO_RESULTS_TITLE'),
      description: t('TRANSACTIONS_NO_RESULTS_DESCRIPTION'),
    }),
    [t],
  );

  return (
    <div className={styles.page}>
      <PageHeader title={t('TRANSACTIONS_TITLE')} />
      <TransactionsTable
        module={module}
        extraFilters={assistantFilters}
        certificateType={MODULE_CERTIFICATE_TYPES[module]}
        emptyState={emptyState}
        noResults={noResults}
      />
    </div>
  );
};
